// extracted by mini-css-extract-plugin
export default {"PaymentAlert_modal":"PaymentAlert_PaymentAlert_modal__rBadY","PaymentAlert_wrap":"PaymentAlert_PaymentAlert_wrap__p4TZS","PaymentAlert_img":"PaymentAlert_PaymentAlert_img__JvtFT"};